import {authttp, zero} from "~/utils";

export default {
    login: async (username, password) => {
        return authttp.post("/auth/login-token/", {username, password});
    },
    tokenRefresh: async () => {
        return authttp.post("/auth/refresh-token/", {
            refresh_token: localStorage.getItem("_rf_")
        });
    },
    validateToken: async () => {
        return authttp.post("/auth/verify-token/", {});
    },
    requestNewPassword: async username_or_email => {
        return authttp.post("/auth/profile/password-recovery/", {user: username_or_email});
    },
    resetPasswordConfirm: async values => {
        return authttp.post("auth/profile/reset-password-confirm/", values);
    },
    token: async () => {
        return zero.post('/auth/token-jwt/');
    }
};
